
import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
  <footer className="app-footer" style={{ backgroundColor: '#f0f0f0', color: '#333', padding: '20px', textAlign: 'center', fontSize: '0.9em' }}>
    <p>{t('app.footer')}</p>
    <p>
      <Link to="/privacy" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>{t('buttons.privacyPolicy')}</Link>
      |
      <Link to="/contact" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>{t('buttons.contactUs')}</Link>
      |
      <Link to="/terms-of-service" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>{t('buttons.termsOfService')}</Link>
      |
      <Link to="/cookie-policy" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>{t('buttons.cookiePolicy')}</Link>
    </p>
  </footer>
  )
};

export default Footer;
